var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 10,
    viewBox: "0 0 22 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.52083 1C1.85156 1.63542 2.35208 2.22396 2.99115 2.7474C4.78125 4.2151 7.65573 5.16667 10.8958 5.16667C14.1359 5.16667 17.0099 4.2151 18.8005 2.7474C19.4396 2.22396 19.9401 1.63542 20.2708 1M13.488 5.16667L14.5667 9.19115M17.8505 3.78854L20.7969 6.73437M1 6.73437L3.94635 3.78802M7.2125 9.19167L8.29063 5.16667",
    stroke: "#979AA8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.7d01e5d9cdeae09336a79f5e357bca2e.svg";
export { ForwardRef as ReactComponent };